<template>
    <div>
        <div v-if="item" class="row">
            <div class="col-sm mb-2">
                <div ref="techDiv" class="card h-100">
                    <div class="card-header p-2">
                        <span> 要員情報</span>
                        <span v-if="item.user_id" class="pr-2">(te.{{item.te_id}}/us.{{item.user_id}}) </span>
                        <span class="text-nowrap">
                            <span v-if="item.user_id" class="btn btn-link py-0 px-0 pr-2" @click="openPrivateInfo">個人詳細</span>
                            <span v-else class="text-muted px-2">未登録</span>
                            <a class="text-decoration-none px-2" :href="item.resume" target="_blank">Excel</a>
                            <a v-if="item.resume_pdf" class="btn btn-link py-0 px-2" :href="item.resume_pdf" target="_blank">PDF</a>
                            <span v-else class="text-muted px-2">PDF</span>
                            <span class="btn btn-link py-0" @click="openTechSet">編集</span>
                        </span>
                    </div>
                    <div ref="btech" class="card-body p-2 let-space-1">
                        <div ref="name">氏　名：{{item.name}}&nbsp;（{{item.age}}歳・{{item.gender == '0' ? '男性' : '女性'}}）</div>
                        <div ref="country">国　籍：{{item.country}}</div>
                        <div ref="relation">
                            <div v-if="item.relation_cmp">所　属：{{converVal('relation_cmp', item.relation_cmp)}}</div>
                            <div v-else>所　属：弊社個人事業主</div>
                        </div>
                        <div ref="nearest_station">最寄駅：{{item.nearest_station}}</div>
                        <div ref="exper">経　験：{{item.exper}} 年</div>
                        <div ref="hope_price">
                            <div v-if="item.hope_price_start == item.hope_price_end">単　金：{{item.hope_price_end}} 万円</div>
                            <div v-else>単　金：{{item.hope_price_start}} ~ {{item.hope_price_end}} 万円</div>
                        </div>
                        <div ref="work_start_date">稼働日：{{converDate('work_start_date', item.work_start_date)}}</div>
                        <div ref="jp_level">日本語：{{converVal('jp',item.jp_level)}}</div>
                        <div ref="en_level">
                            <div v-if="item.en_level">英　語：{{converVal('en',item.en_level)}}</div>
                        </div>
                        <div ref="skill">
                            <div v-if="item.skill"><div>スキル：</div><div class="pl-5 break-row">{{item.skill}}</div></div>
                        </div>
                        <div ref="hope">
                            <div v-if="item.hope"><div>希　望：</div><div class="pl-5 break-row">{{item.hope}}</div></div>
                        </div>
                        <div ref="note">
                            <div v-if="item.note"><div>備　考：</div><div class="pl-5 break-row">{{item.note}}</div></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm mb-2">
                <div class="card h-100">
                    <div class="card-header p-2">
                        提案用情報
                    </div>
                    <div class="card-body p-2 let-space-1 h-100">
                        <div v-if="item.tech_info_pub" class="break-row">{{item.tech_info_pub}}</div>
                        <div v-else class="text-danger">提案用の情報を作成してください。</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-2">
            <div class="card-header p-2">
                平行提案情報（Open）
            </div>
            <div v-if="apps" class="card-body p-2">
                <template v-if="apps.length > 0">
                    <tech-apps v-for="(item,idx) in apps" :key="item.id" :item="item" :idx="idx"></tech-apps>
                </template>
                <div v-else class="text-muted">平行提案がありません</div>
            </div>
        </div>

        <!-- 個人情報 -->
        <private-info ref="privateInfo"></private-info>
        <!-- 確認メッセージ -->
        <tech-set ref="techSet"></tech-set>
    </div>
</template>

<script>
    import {converVal} from 'pages/commons/form/selectList'
    import {isOverProjStartDate} from 'pages/commons/form/comFunc'
    import PrivateInfo from 'pages/commons/modal/privateInfo/PrivateInfo'
    import TechSet from './TechSet'
    import TechApps from './TechApps'

    export default {
        props: {
            item: Object,
            apps: Array
        },
        components: {
            PrivateInfo,
            TechSet,
            TechApps
        },
        methods: {
            openPrivateInfo (userId) {
                this.$refs.privateInfo.openThis(this.item.user_id)
            },
            openTechSet () {
                this.$refs.techSet.openThis(this.item)
            },
            makeTechPub () {
                let Str = ""
                Str += this.$refs.name.innerText + '\n'
                Str += this.$refs.country.innerText + '\n'
                Str += this.$refs.relation.innerText + '\n'
                Str += this.$refs.nearest_station.innerText + '\n'
                Str += this.$refs.exper.innerText + '\n'
                Str += this.$refs.hope_price.innerText + '\n'
                Str += this.$refs.work_start_date.innerText + '\n'
                Str += this.$refs.jp_level.innerText + '\n'
                Str += this.$refs.en_level.innerText ? this.$refs.en_level.innerText + '\n' : ""
                Str += this.$refs.skill.innerText ? this.$refs.skill.innerText + '\n' : ""
                Str += this.$refs.hope.innerText ? this.$refs.hope.innerText + '\n' : ""
                Str += this.$refs.note.innerText ? this.$refs.note.innerText + '\n' : ""
                return Str
            },
            converDate (name, value) {
                if (!this.isOverStart(value)) {
                    return this.converVal(name, value)
                }
                return '即日～'
            },
            converVal (name, val) {
                return converVal(name,val)
            },
            isOverStart (val) {
                return isOverProjStartDate(val)
            },
        }
    }
</script>

<style lang="stylus" scoped>
    .break-row
        white-space:pre-wrap
        word-wrap:break-word
</style>
